export enum ERealEstateType {
  HOUSE = 'house',
  TOWNHOUSE = 'townhouse',
  LAND = 'land',
  COTTAGE = 'cottage',
  BUILD = 'build',
}
